var map = {
	"./cards/SebikoGamingCard-1.json": 5861,
	"./instagram/CreativeIdeas-1.json": 6558,
	"./instagram/StrokeText-2.json": 90,
	"./linkedin/Purple-1.json": 4508,
	"./presentations/CleanSlide-1.json": 5034,
	"./presentations/CleanSlideImage-2.json": 2830,
	"./presentations/Ocean-3.json": 1864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2499;